import React from "react";
import { useEffect } from "react";
import url from "../config/Config";
import { useState } from "react";

const Producto = (props) => {
    // Producto detalle => next
    return <div>Producto</div>;
};

export default Producto;
